import { useEffect } from 'react'
import type { Query } from '@tanstack/react-query'
import { queryErrorEventBus } from '@/lib//misc/EventBus'
import { AxiosResponse } from 'axios'

export function useQueryErrorListener(
  handler: (payload: {
    error: unknown
    query: Query
    response?: AxiosResponse
  }) => void
) {
  useEffect(() => {
    queryErrorEventBus.on('query:error', handler)
    return () => {
      queryErrorEventBus.off('query:error', handler)
    }
  }, [handler])
}
